module.exports = __webpack_public_path__ + "img/UserCheckRounded.3af0df1d.svg";